import { gql } from 'apollo-angular'

export const GET_NOTIFICATION_OPT_OUTS = gql`
  query GetNotificationOptOuts {
    MagazineNotificationOptOuts(select: true, limit: -1) {
      docs {
        id
        magazine {
          id
        }
      }
    }
  }
`
